import { useState, useEffect } from "react";
import "./stickymenu.css"; // Import the CSS file
import MenuTick from "../assets/images/menuiconwhite.png"; // Adjust the path if needed
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonFab,
  IonFabButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonImg,
  IonActionSheet,
} from '@ionic/react';

export default function StickyMenu() {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const triggerPoint = 164; // Change this if needed
      setIsSticky(scrollY > triggerPoint);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  //possible infinite text crawl here

  return (
    <div className="container" style={{justifyContent: "center", display: "flex"}}>
      {/* Content */}

      {/* Sticky Menu */}
      <div className={`menu ${isSticky ? "sticky" : ""}`} style={{justifyContent: "center", display: "flex"}}>
      <IonCol style={{top:"8px", left:"15px"}} className="imagecolumn">
      <img src={MenuTick}
      alt="Decen Tick Icon"
      style={{ maxWidth: "26px", maxHeight: "30px", objectFit: "contain", opacity: "75%"}}
    />
    </IonCol>
      <IonCol style={{top:"10px", fontFamily: "GeistMono, sans-serif", fontWeight: "bold",  opacity: "75%"}}>
        <nav>
          <a href="#">Demo</a>
          <a href="#">About</a>
          <a href="#">Features</a>
          <a href="#">Contact</a>
          <a href="#">Beta</a>
        </nav>
        </IonCol>
      </div>
      <p> <br /> <br /> </p>
    </div>
  );
}
